import React, { useState } from 'react';
import intl from 'react-intl-universal';

import styles from './index.module.less';
import { ArticleType } from '@/type/article';
import { NextImage } from '@/components/public';
import { Typography } from 'antd';

function ListItem({ dataSource }: { dataSource: ArticleType }) {
    const [showEllipsis, setShowEllipsis] = useState<boolean>(false);
    const [isShowAll, setIsShowAll] = useState<boolean>(false);

    /** 展开/收起 */
    const switchShow = (e: any) => {
        e.stopPropagation && e.stopPropagation();
        // 展示更多
        setIsShowAll(!isShowAll);
    };

    const { title, introduction } = dataSource;

    return (
        <>
            <div className={styles.title__wrapper}>
                <div className={styles.icon__Q}>
                    <NextImage src="/icon/faq/icon-q.webp" needPrefix layout="fill" alt="Q" />
                </div>
                <p>{title}</p>
            </div>

            {Boolean(introduction) && (
                <div className={styles.introduction__wrapper}>
                    <div className={styles.icon__A}>
                        <NextImage src="/icon/faq/icon-a.webp" needPrefix layout="fill" alt="A" />
                    </div>
                    <div>
                        <Typography.Paragraph
                            style={{ marginBottom: 0 }}
                            ellipsis={
                                isShowAll
                                    ? false
                                    : {
                                          rows: 8,
                                          expandable: false,
                                          onEllipsis: (ellipsis: boolean) => setShowEllipsis(ellipsis),
                                      }
                            }
                            className={styles.intro}
                        >
                            {introduction}
                        </Typography.Paragraph>
                    </div>
                </div>
            )}
            {showEllipsis && (
                <div onClick={switchShow} className={styles.more}>
                    <span>
                        {isShowAll ? intl.get('Common.PackUp').d('收起') : intl.get('Common.SeeMore').d('更多')}
                    </span>
                    <i
                        className="iconfont icon-jiantou"
                        style={{
                            fontSize: '14px',
                            marginLeft: 4,
                            transform: `rotateZ(${isShowAll ? '-90deg' : '90deg'})`,
                        }}
                    />
                </div>
            )}
        </>
    );
}

export default ListItem;
